export default __webpack_public_path__ + "static/partner-vermont-hero-891a7385a05d45d3a5075ad3c79e3771.jpg";